import { useTheme } from "@sundae/react-hooks";
import { Loader, SundaeSwapLogo, Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import React from "react";

import GradientBackground from "../GradientBackground";

const LoadingScreen: React.FC<{ text?: string }> = ({ text }) => {
  const { theme } = useTheme();
  return (
    <div className={cx({ "bg-dark-200": theme === "dark" })}>
      <div
        aria-busy="true"
        className={cx("relative min-h-screen overflow-hidden", "dark:bg-gray-900 dark:bg-none")}
      >
        <div
          className={cx(
            "absolute flex h-96 w-96 flex-col items-center justify-center",
            toolkitCx.recipes.center.both()
          )}
        >
          <SundaeSwapLogo className="h-12 w-12" />

          <Loader className="mt-6" size="medium" />

          {text && (
            <Text tag="p" weight="bold">
              {text}
            </Text>
          )}
        </div>
      </div>
      <GradientBackground />
    </div>
  );
};

export default LoadingScreen;
